/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetScenarioPlanRequest} from '@cash-web/protos/squareup/franklin/app/scenario.pb'
import {GetScenarioPlanResponse} from '@cash-web/protos/squareup/franklin/app/scenario.pb'


export const getScenarioPlan = (request:GetScenarioPlanRequest, options?: CashRequestOptions) => post<GetScenarioPlanRequest, GetScenarioPlanResponse>("/2.0/cash/get-scenario-plan", request, {...options, rejectOnError: true })